import React from "react";
import "./About.css";
import imgAbout from "../../img/2.jpg";
import WhyUs from "../../Components/WhyUs/WhyUs";
function About() {
  return (
    <div className="About  ">
      <div className="container pt-1">
        <p className="text-center fw-bold fs-1">من نحن </p>
        <div className="row my-5 align-items-center">
          <div className="col-lg-6">
            <div className="img mb-3">
              <img src={imgAbout} alt="" />
            </div>
          </div>

          <div className="col-lg-6">
            <h3>شركة الشحن الأفضل في الرياض: توصيل سريع وآمن لبضائعك! 🚀📦</h3>
            <div className="info">
              <p>
                هل تبحث عن شركة شحن موثوقة في الرياض لتنقل بضائعك بأمان وسرعة؟
                لا تبحث بعيدًا! نحن نقدم خدمات شحن شاملة تلبي جميع احتياجاتك
                اللوجستية.
              </p>
              <p>
                نحن شركة رائدة في مجال الشحن والخدمات اللوجستية في الرياض، نتمتع
                بخبرة واسعة اكتسبناها على مدار سنوات من العمل الجاد والتفاني في
                تقديم خدمات عالية الجودة لعملائنا. نضع رضا عملائنا في مقدمة
                أولوياتنا، ونسعى جاهدين لتلبية احتياجاتهم وتجاوز توقعاتهم في كل
                مرة.
              </p>
              <h5>رؤيتنا:</h5>
              <p>
                أن نكون الشركة الرائدة في مجال الشحن والخدمات اللوجستية في
                المملكة العربية السعودية، وأن نكون الخيار الأول لعملائنا من خلال
                تقديم خدمات مبتكرة وموثوقة وعالية الجودة.
              </p>
            </div>

            <ul>
              <h5 className="fw-bold fs-3 p-0 m-0"> خدماتنا:</h5>
              <li>شحن داخلي: نغطي جميع أنحاء الرياض وضواحيها.</li>
              <li>
                شحن دولي: نصل إلى جميع أنحاء العالم بشبكة واسعة من الشركاء
                الدوليين.
              </li>
              <li>
                تخزين البضائع: نوفر مساحات تخزين آمنة ومؤمنة لحماية بضائعك.
              </li>
              <li>
                التغليف والتعبئة: نضمن سلامة بضائعك بأفضل مواد التغليف والتعبئة.
              </li>
              <li>
                التأمين على الشحنات: نوفر لك راحة البال بتأمين شامل على شحناتك.
              </li>
              <li>
                تتبع الشحنات: يمكنك تتبع شحناتك في الوقت الفعلي لمعرفة موقعها
                وحالتها.
              </li>
            </ul>

            <ul>
              <h5 className="fw-bold fs-3 p-0 m-0"> لماذا تختارنا؟</h5>{" "}
              <li>
                خبرة طويلة: لدينا سنوات من الخبرة في مجال الشحن والخدمات
                اللوجستية.
              </li>
              <li>
                فريق محترف: فريق عملنا مدرب على أعلى مستوى لتقديم أفضل خدمة.
              </li>
              <li>
                أسعار تنافسية: نقدم أسعارًا تنافسية تناسب جميع الميزانيات.
              </li>
              <li>
                خدمة عملاء متميزة: نحن نهتم برضا عملائنا ونقدم لهم الدعم اللازم
                في كل خطوة.
              </li>
            </ul>

            <ul>
              <h5 className="fw-bold fs-3 p-0 m-0">مهمتنا:</h5>
              <li>
                توفير حلول شحن ولوجستية متكاملة تلبي احتياجات عملائنا المتنوعة.{" "}
              </li>
              <li> ضمان سلامة وأمان البضائع وتوصيلها في الوقت المحدد.</li>
              <li>
                بناء علاقات طويلة الأمد مع عملائنا قائمة على الثقة والاحترام
                المتبادل.
              </li>
              <li>
                المساهمة في تطوير قطاع الشحن والخدمات اللوجستية في المملكة.
              </li>
            </ul>

            <ul>
              <h5 className="fw-bold fs-3 p-0 m-0">قيمنا:</h5>
              <li>
                النزاهة: نلتزم بأعلى معايير النزاهة والشفافية في جميع تعاملاتنا.
              </li>
              <li>
                الاحترافية: نقدم خدماتنا بأعلى مستوى من الاحترافية والكفاءة.
              </li>
              <li>
                الابتكار: نسعى دائمًا لتطوير خدماتنا وتبني أحدث التقنيات والحلول
                المبتكرة.
              </li>
              <li>
                العمل الجماعي: نؤمن بقوة العمل الجماعي وأهمية التعاون لتحقيق
                الأهداف المشتركة.
              </li>
              <li>
                خدمة العملاء: نضع رضا عملائنا في مقدمة أولوياتنا ونسعى لتقديم
                خدمة عملاء استثنائية.
              </li>
            </ul>
            <p>اتصل بنا اليوم واحصل على عرض أسعار مجاني! 📞</p>

            <h1> شركة الشحن الأفضل في الرياض: نوصل ثقتك! 🤝</h1>
          </div>
        </div>
      </div>

      <WhyUs />
    </div>
  );
}

export default About;
